<div class="web-contents">
	<div
		*ngIf="showBar()"
		id="DOMWebHeader"
		class="container-liquid barGeneral"
	>
		<!-- img *ngIf="showTitleProject()" class="menuu" src="/assets/img/new/menu.jpg" alt="menú" (click)="onMenu()" / -->
		<img
			*ngIf="showTitleProject()"
			class="menuu"
			src="/assets/img/new/home.png"
			alt="Home"
			(click)="onReturnHome()"
		/>
		<img
			*ngIf="showReturn()"
			class="menuu"
			src="/assets/img/new/arrow.png"
			alt="Retorno"
			(click)="onReturn()"
		/>

		<img
			class="logoRivisa"
			src="/assets/img/rivisa-logo-{{
				modelService.getLanguage().currentLanguage
			}}.png"
			alt="Rivisa"
		/>
		<div *ngIf="showTitleProject()">
			<div
				id="DOMWebHeader_titleProject"
				class="text-truncate project-namelock"
			></div>
			<div
				id="DOMWebHeader_statusProject"
				class="project-statuslock"
			></div>
		</div>
	</div>
	<div id="webContents" class="container-liquid body">
		<router-outlet> </router-outlet>
	</div>
</div>

<!--
<ul class="menuEditorProjects" *ngIf="showMenu()"><li *ngIf="readyForRender" class="itemMenuEditor" (click)="send ForAproval()">
		<i class="fa fa-eye"></i>{{ modelService.getString('builder_ view_detail') }}</li>
	<li *ngIf="!readyForRender" class="noReadyForRender"><i class="fa fa-eye"></i>{{ modelService.getString('builder_ view_detail') }}</li>
	<li class="itemMenuEditor" (click)="onReturn()"><i class="fa fa-backward"></i>{{ modelService.getString('app _goto_home') }}</li>
</ul>
-->

<script
	src="https://code.jquery.com/jquery-3.4.1.slim.min.js"
	integrity="sha384-q8i/X+965DzO0rT7abK41JStQIAqVgRVzpbzo5smXKp4YfRvH+8abtTE1Pi6jizo"
	crossorigin="anonymous"
></script>
<app-alert #alertWindow></app-alert>
